<div class="col-sm-2 documents-status-filter">
    <div class="parcels-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="parcels-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="superAdmin" #superAdmin (change)="changeFilter()">
                <label for="superAdmin"><svg-checked></svg-checked></label>
                <span>Admin</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="companyAdmin" #companyAdmin (change)="changeFilter()">
                <label for="companyAdmin"><svg-checked></svg-checked></label>
                <span>Company Admin</span>
            </label>
        </div>


        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="propertyManager" #propertyManager (change)="changeFilter()">
                <label for="propertyManager"><svg-checked></svg-checked></label>
                <span>Staff</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="resident" #resident (change)="changeFilter()">
                <label for="resident"><svg-checked></svg-checked></label>
                <span>Resident</span>
            </label>
        </div>

        <hr>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="invited" #invited (change)="changeFilter()">
                <label for="invited"><svg-checked></svg-checked></label>
                <span>Invited</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="notInvited" #notInvited (change)="changeFilter()">
                <label for="notInvited"><svg-checked></svg-checked></label>
                <span>Not Invited</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="active" #active (change)="changeFilter()">
                <label for="active"><svg-checked></svg-checked></label>
                <span>Active</span>
            </label>
        </div>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/admin/user/user-filter/user-filter.component.html